/* lp-coastal-terry-desert-oasis.js
 * Scoped to elements inside .lp-ct. Handles:
 *   1. Color swatch image-swap on product cards (and variant-id binding for the Add button)
 *   2. AJAX add-to-cart via /cart/add.js, with a CustomEvent for the theme's cart drawer
 *   3. Sticky bottom CTA: label flip after scrolling past the 'pieces' section
 */
(function () {
  'use strict';

  var root = document.querySelector('.lp-ct');
  if (!root) return;

  // Prevent iOS Safari rubber-band horizontal pan that exposes white space on
  // either side of the page when you long-press and drag. Scoped to this page
  // by only running when the LP section is in the DOM.
  var html = document.documentElement;
  var body = document.body;
  html.style.overscrollBehaviorX = 'none';
  body.style.overscrollBehaviorX = 'none';
  html.style.overflowX = 'hidden';
  body.style.overflowX = 'hidden';
  // Lock touch panning to vertical only on the entire page while this LP is mounted.
  html.style.touchAction = 'pan-y';
  body.style.touchAction = 'pan-y';
  root.style.touchAction = 'pan-y';
  // Block horizontal swipe gestures with two fingers (pinch zoom out reveals space)
  document.addEventListener('touchmove', function (e) {
    if (e.touches.length > 1) return; // allow pinch zoom
    var t = e.touches[0];
    if (!t._lpStartX) return;
    var dx = Math.abs(t.pageX - t._lpStartX);
    var dy = Math.abs(t.pageY - t._lpStartY);
    if (dx > dy && dx > 8) e.preventDefault();
  }, { passive: false });
  document.addEventListener('touchstart', function (e) {
    if (!e.touches[0]) return;
    e.touches[0]._lpStartX = e.touches[0].pageX;
    e.touches[0]._lpStartY = e.touches[0].pageY;
  }, { passive: true });

  // --- 1. Swatch image-swap & variant binding -----------------------------
  // Use event delegation so swatches bound after the theme editor re-renders or
  // after Shopify's storefront app injection still respond.
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.lp-ct-sw');
    if (!sw || !sw.closest('.lp-ct')) return;
    if (sw.getAttribute('aria-disabled') === 'true') { e.preventDefault(); return; }
    var fs = sw.closest('[data-swatches]');
    var card = sw.closest('[data-product-handle]');
    if (!fs || !card) return;
    e.preventDefault();
    fs.querySelectorAll('button.lp-ct-sw').forEach(function (s) {
      s.setAttribute('aria-pressed', s === sw ? 'true' : 'false');
    });
    var url = sw.getAttribute('data-img');
    var alt = sw.getAttribute('data-alt');
    var vid = sw.getAttribute('data-variant-id');
    var leadImg = card.querySelector('[data-lead]');
    if (leadImg && url) {
      leadImg.src = url;
      // Clear srcset so the browser uses the new src instead of the responsive set
      if (leadImg.hasAttribute('srcset')) leadImg.removeAttribute('srcset');
      if (alt) leadImg.alt = alt;
    }
    var addBtn = card.querySelector('[data-add]');
    if (addBtn && vid) addBtn.setAttribute('data-variant-id', vid);
  }, true);

  // --- 2. AJAX add-to-cart ------------------------------------------------
  function setBtnState(btn, text, disabled) {
    btn.textContent = text;
    btn.disabled = !!disabled;
  }

  root.querySelectorAll('[data-add]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var vid = btn.getAttribute('data-variant-id');
      if (!vid) return;
      var originalLabel = btn.textContent;
      setBtnState(btn, 'Adding...', true);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 })
      })
        .then(function (r) { return r.json().then(function (json) { return { ok: r.ok, status: r.status, json: json }; }); })
        .then(function (res) {
          if (!res.ok) {
            setBtnState(btn, 'Try again', false);
            setTimeout(function () { setBtnState(btn, originalLabel, false); }, 1800);
            return;
          }
          // Notify the theme's cart drawer (Impulse listens for ajaxProduct:added on document)
          try {
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: res.json }));
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: res.json }));
          } catch (err) { /* noop */ }
          setBtnState(btn, '✓ Added', true);
          setTimeout(function () { setBtnState(btn, originalLabel, false); }, 1600);
        })
        .catch(function () {
          setBtnState(btn, 'Try again', false);
          setTimeout(function () { setBtnState(btn, originalLabel, false); }, 1800);
        });
    });
  });

  // --- 3. Sticky CTA scroll state -----------------------------------------
  var sticky = root.querySelector('.lp-ct-sticky') || document.querySelector('.lp-ct-sticky');
  if (sticky) {
    var triggerSel = sticky.getAttribute('data-sticky-trigger') || '#pieces';
    var trigger = document.querySelector(triggerSel);
    var labelEl = sticky.querySelector('[data-sticky-label]');
    var subEl = sticky.querySelector('[data-sticky-sub]');
    var ctaText = sticky.querySelector('[data-sticky-cta-text]');
    var defLabel = sticky.getAttribute('data-default-label') || '';
    var defSub = sticky.getAttribute('data-default-sub') || '';
    var scLabel = sticky.getAttribute('data-scrolled-label') || defLabel;
    var scSub = sticky.getAttribute('data-scrolled-sub') || defSub;
    var defCtaText = ctaText ? ctaText.textContent : '';

    function setState(scrolled) {
      if (!labelEl || !subEl) return;
      labelEl.textContent = scrolled ? scLabel : defLabel;
      subEl.textContent = scrolled ? scSub : defSub;
      if (ctaText) ctaText.textContent = scrolled ? 'Add the Set · $140' : defCtaText;
    }

    if (trigger && 'IntersectionObserver' in window) {
      // When `trigger` has been scrolled past (its bottom is above the viewport top), flip state.
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          // boundingClientRect.bottom < 0 means trigger is above the viewport
          var scrolledPast = entry.boundingClientRect.bottom < 0;
          setState(scrolledPast && !entry.isIntersecting);
        });
      }, { root: null, threshold: 0, rootMargin: '0px 0px 0px 0px' });
      io.observe(trigger);
      // Also listen to scroll for the past-trigger case the IO can't catch when fully scrolled past
      var onScroll = function () {
        if (!trigger) return;
        var rect = trigger.getBoundingClientRect();
        setState(rect.bottom < 0);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  // --- 4. Size-guide modal ----------------------------------------------
  function openModal(id) {
    var modal = document.getElementById(id);
    if (!modal) return;
    var lazyEls = modal.querySelectorAll('[data-src]');
    lazyEls.forEach(function (el) {
      var target = el.getAttribute('data-src');
      // Swap if the current src is the inline SVG placeholder or empty
      if (target && el.getAttribute('src') !== target) {
        el.src = target;
      }
    });
    modal.classList.add('is-open');
    document.body.classList.add('lp-ct-modal-open');
    var closeBtn = modal.querySelector('.lp-ct-modal-close');
    if (closeBtn) closeBtn.focus();
  }
  function closeModal(modal) {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.body.classList.remove('lp-ct-modal-open');
  }
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-lp-ct-modal-open]');
    if (trigger) {
      e.preventDefault();
      openModal(trigger.getAttribute('data-lp-ct-modal-open'));
      return;
    }
    var closeEl = e.target.closest('[data-lp-ct-modal-close]');
    if (closeEl) {
      e.preventDefault();
      closeModal(closeEl.closest('.lp-ct-modal'));
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var open = document.querySelector('.lp-ct-modal.is-open');
      if (open) closeModal(open);
    }
  });

  // --- 5. Lift third-party floating widgets above the sticky bottom bar -------
  // Some widgets (Gorgias chat, newsletter signup bars) set their `bottom` via
  // inline JS at load time, which beats CSS specificity. Re-pin them on each
  // mutation so they always sit above .lp-ct-sticky (~90px tall).
  function liftWidgets() {
    var selectors = [
      '#chat-button',
      '#chat-input',
      '#chat-campaigns',
      '[id^="gorgias-chat"]:not(#gorgias-chat-storage-sync)',
      '[class*="newsletter-popup"]:not(.modal)',
      '[class*="newsletter__bar"]',
      '[class*="signup-bar"]',
      '[class*="email-signup-bar"]',
      '[class*="kl-private-reset-css"]',
      '[class*="klaviyo-form"]',
      '[id*="klaviyo"]',
      '.footer-sticky-newsletter',
      'iframe[title*="chat" i]',
      'iframe[title*="messenger" i]',
      '#shopify-pc__banner',
      '.shopify-pc__banner__dialog'
    ];
    var lifted = 'calc(env(safe-area-inset-bottom, 0px) + 96px)';
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        // Skip elements that aren't bottom-anchored already
        var cs = getComputedStyle(el);
        if (cs.position !== 'fixed' && cs.position !== 'sticky') return;
        // For Klaviyo specifically, only lift while it's the small teaser. If
        // the element is taller than ~200px it's the expanded signup modal and
        // we must leave its own positioning alone (otherwise it floats up off
        // the viewport).
        if (/klaviyo|kl-private/i.test(sel)) {
          var r = el.getBoundingClientRect();
          if (r.height > 200 || r.width > 360) {
            el.style.removeProperty('bottom');
            return;
          }
        }
        el.style.setProperty('bottom', lifted, 'important');
      });
    });
  }
  liftWidgets();
  var liftObs = new MutationObserver(function () { liftWidgets(); });
  liftObs.observe(document.body, { childList: true, subtree: true });
  // Also re-run periodically for the first 10s in case widgets load via setTimeout
  var liftIntervalCount = 0;
  var liftInterval = setInterval(function () {
    liftWidgets();
    if (++liftIntervalCount > 20) clearInterval(liftInterval);
  }, 500);
})();
